import { useEffect, useState } from 'react'
import { LOCATION_NOTFOUND_MESSAGE } from '../constants/values'

export function useFetchLocationAddress(position: L.LatLng | null) {
  const [location, setLocation] = useState({ countryCode: '', location: '' })
  useEffect(() => {
    if (!position) return

    const baseUrl = 'https://nominatim.openstreetmap.org/reverse'
    const latitude = position.lat
    const longitude = position.lng
    const format = 'json'
    const language = 'en'

    const apiUrl = `${baseUrl}?format=${format}&lat=${latitude}&lon=${longitude}&accept-language=${language}`
    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        const countryCode = data?.address?.country_code || ''
        const location =
          [
            data?.address?.house_number,
            data?.address?.road,
            data?.address?.hamlet,
            data?.address?.city ||
              data?.address?.town ||
              data?.address?.village,
            data?.address?.municipality,
            data?.address?.district,
            data?.address?.county,
            data?.address?.state,
            data?.address?.postcode,
            data?.address?.country,
          ]
            .filter(Boolean)
            .join(', ') || LOCATION_NOTFOUND_MESSAGE
        const loc = {
          countryCode,
          location,
        }
        setLocation(loc)
      })
      .catch((error) => console.error('Error fetching data:', error))
  }, [position])

  return location
}
